module.exports = __webpack_public_path__ + "static/media/bg.9fe4d570.svg";